import { ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS, ADD_TO_CART_ERROR, NO_SIZE_SELECTED_ERROR } from '../constants/ActionTypes';
import { pdpConstants } from '@ynap/product-details-state';

const { CHANGE_SELECTED_SKU } = pdpConstants;

const initialState = {
    loading: false,
    error: null,
};

export default function addToCart(state = initialState, action) {
    switch (action.type) {
        case ADD_TO_CART_REQUEST: {
            return { ...state, loading: true, error: null };
        }
        case ADD_TO_CART_SUCCESS: {
            return { ...state, loading: false, lastAddedItem: action.lastAddedItem };
        }
        case CHANGE_SELECTED_SKU: {
            return { ...state, error: null };
        }
        case NO_SIZE_SELECTED_ERROR:
        case ADD_TO_CART_ERROR:
            return { ...state, loading: false, error: { body: { error: action.error, partNumber: action.partNumber } } };
        case 'UPDATE_SELECTED_PRODUCT':
        case 'UNSELECT_PRODUCT':
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
}
